"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    var _a, _b;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.cells) || element.value.cells.length === 0) {
        return '';
    }
    const { cells, headerRow, columns } = element.value;
    const numCols = (columns === null || columns === void 0 ? void 0 : columns.length) || ((_b = cells[0]) === null || _b === void 0 ? void 0 : _b.length) || 0;
    const cellToText = (cell) => {
        if (!(cell === null || cell === void 0 ? void 0 : cell.value)) {
            return '';
        }
        return (0, rich_text_1.slateToMarkdown)(cell.value, {
            allowHtmlStyles: context.withStyle,
            allowAlignment: context.withStyle,
            allowCaptionHtml: context.withStyle,
        })
            .trim()
            .replace(/\n/g, ' ');
    };
    const padCell = (text, minWidth = 8) => {
        return text.padEnd(minWidth, ' ');
    };
    const lines = [];
    cells.forEach((row, rowIndex) => {
        if (!row || row.length === 0) {
            return;
        }
        const rowCells = row.map((cell) => {
            const text = cellToText(cell);
            return padCell(text);
        });
        lines.push(`| ${rowCells.join(' | ')} |`);
        if (rowIndex === 0 && headerRow) {
            const separator = Array(numCols)
                .fill('---')
                .map((s) => padCell(s))
                .join(' | ');
            lines.push(`| ${separator} |`);
        }
    });
    if (!headerRow && lines.length > 0) {
        const separator = Array(numCols)
            .fill('---')
            .map((s) => padCell(s))
            .join(' | ');
        lines.splice(1, 0, `| ${separator} |`);
    }
    if (lines.length === 0) {
        return '';
    }
    return lines.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
